import styled from 'styled-components';

import { DefaultUserIcon, DefaultUserIconVariant } from '../Icons';
import ImageWithRetry from '../Image/ImageWithRetry';

type size = 'large' | 'medium' | 'small';

type Props = {
  size: size;
  thumbnailUrl?: string;
};

const Thumbnail = ({ size, thumbnailUrl }: Props) => {
  const _size = size === 'large' ? 160 : size === 'medium' ? 56 : 40;

  return (
    <SWrapper $size={_size}>
      {thumbnailUrl ? (
        <ImageWithRetry
          src={thumbnailUrl}
          alt={'썸네일 이미지'}
          width={_size}
          height={_size}
          className="thumbnail-image"
        />
      ) : (
        <DefaultUserIcon
          className="default-image"
          variant={DefaultUserIconVariant.NO_BORDER}
          style={{ borderRadius: '50%', overflow: 'hidden' }}
        />
      )}
    </SWrapper>
  );
};

export default Thumbnail;

const SWrapper = styled.div<{ $size: number }>`
  width: ${({ $size }) => $size ?? 40}px;
  height: ${({ $size }) => $size ?? 40}px;
  min-width: ${({ $size }) => $size ?? 40}px;
  min-height: ${({ $size }) => $size ?? 40}px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.color.line.line_6};
  border-radius: 100px;
  overflow: hidden;

  .thumbnail-image {
    object-fit: cover;
  }

  .default-image {
    width: 100% !important;
    height: 100% !important;
    min-width: 100% !important;
    min-height: 100% !important;
  }
`;
